.logo {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
